import { ESolarSolutionType } from "../enums/sola-solution-type";

export const getSolarEstimationTypeIcon = (type: ESolarSolutionType) => {
  switch (type) {
    case ESolarSolutionType.BOTH:
      return { solarPower: "solar_power", waterDrop: "water_drop" };

    case ESolarSolutionType.WATER_HEATING_SYSTEM:
      return { solarPower: undefined, waterDrop: "water_drop" };

    default:
      return { solarPower: "solar_power", waterDrop: undefined };
  }
};
